import i18n from 'modules/core/lib/i18n'

import type IncidenceChanges from 'modules/bookkeepers/store/collections/changes'
import type { Files } from 'modules/bookkeepers/store/collections/files'
import type IncidenceDetail from 'modules/bookkeepers/store/models/IncidenceDetail'
import { InfoCallout } from 'modules/payroll_bundle/pages/IncidenceDetailPage/_InfoCallout'
import LeaveInfo from 'modules/payroll_bundle/pages/IncidenceDetailPage/_LeaveInfo'

interface LeaveContentProps {
  incidenceDetailModel: IncidenceDetail
  incidenceFilesCollection: Files
  incidenceChangesCollection: IncidenceChanges
}

export const LeaveContent = ({
  incidenceDetailModel,
  incidenceFilesCollection,
  incidenceChangesCollection,
}: LeaveContentProps) => {
  const isUpdatedLeave =
    incidenceDetailModel.attributes.created_at !== incidenceDetailModel.attributes.updated_at

  const LeaveInfoComponent = () => {
    return (
      <LeaveInfo
        incidenceDetailModel={incidenceDetailModel}
        incidenceFilesCollection={incidenceFilesCollection}
        incidenceChangesCollection={incidenceChangesCollection}
      />
    )
  }

  if (incidenceDetailModel.attributes.deleted_at !== null) {
    return (
      <>
        <InfoCallout label={i18n.t('bookkeepers.incidence.details.deleted_time_off')} />
        <LeaveInfoComponent />
      </>
    )
  }
  if (isUpdatedLeave) {
    return (
      <>
        <InfoCallout label={i18n.t('bookkeepers.incidence.details.updated_time_off')} />
        <LeaveInfoComponent />
      </>
    )
  }
  return <LeaveInfoComponent />
}
